var e = [];
export {
  e as resizeObservers
};
